module.exports = __webpack_public_path__ + "img/slim.6c6c4118.png";